module.exports = __webpack_public_path__ + "static/media/recours-defense.30f40f77.svg";